<template>
    <div class="orderConfirmation text-center">
        <div v-if="!loaded">
            <loading-indicator message="Getting Order Confirmation."></loading-indicator>
        </div>
        <div v-else>
            <shipping-label :confirmationContent="confirmationContent" :label="confirmation"></shipping-label>
        </div>
    </div>
</template>

<script>
import LoadingIndicator from "@/components/layout/LoadingIndicator";
import ShippingLabel from "@/components/confirmation/ShippingLabel";
import Vue from "vue";
export default {
  props: ["confirmationNumber"],
  components: { LoadingIndicator, ShippingLabel },
  data() {
    return {
      label: null,
      confirmationContent: null,
      loaded: false
    };
  },
  methods: {
    getConfirmationContent() {
      axios
        .get("/confirmation/" + this.confirmationNumber)
        .then(response => {
          this.confirmation = response.data;
          this.loadContent();
        })
        .catch(error => {
          this.$router.push("/error");
        });
    },

    loadContent() {
      axios
        .get(Vue.config.HOST_URL + this.confirmation.confirmationPageName, {
          responseType: "text"
        })
        .then(response => {
          this.confirmationContent = response.data;
          this.loaded = true;
        })
        .catch(error => {
          this.handleError(error);
        });
    }
  },
  created() {
    this.getConfirmationContent();
  },
  computed: {}
};
</script>
